module.exports = __webpack_public_path__ + "img/route-cape-town.f94b956a.webp";